export default (attempt = 1, delay = 1.5) => {
    return Math.floor(Math.random() * Math.pow(2, attempt) * delay);
};
